import { render, staticRenderFns } from "./WDR.vue?vue&type=template&id=35b17c8d&scoped=true"
import script from "./WDR.vue?vue&type=script&lang=js"
export * from "./WDR.vue?vue&type=script&lang=js"
import style0 from "./WDR.vue?vue&type=style&index=0&id=35b17c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b17c8d",
  null
  
)

export default component.exports